export const InspiringClimateProjectsTab = () => {
  return "";
};
